module.exports = "<a [href]=\"websiteUrl\" target=\"_blank\" class=\"logo-container\">\n  <alg-logo></alg-logo>\n</a>\n<div class=\"summary\">\n  <alg-header-button class=\"button-recap\"></alg-header-button>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-header/alg-header.component.html
// module id = ./src/app/components/alg-header/alg-header.component.html
// module chunks = main